import apiCalendarPlan from '@/api/calendar-plan'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  data: null
}

export const mutationTypes = {
  updateCalendarPlanStart: '[update calendar plan] Update calendar plan start',
  updateCalendarPlanSuccess:
    '[update calendar plan] Update calendar plan success',
  updateCalendarPlanFailure:
    '[update calendar plan] Update calendar plan failure',

  getCalendarPlanStart: '[update calendar plan] Get calendar plan start',
  getCalendarPlanSuccess: '[update calendar plan] Get calendar plan success',
  getCalendarPlanFailure: '[update calendar plan] Get calendar plan failure'
}

export const actionTypes = {
  updateCalendarPlan: '[update calendar plan] Update calendar plan',
  getCalendarPlan: '[update calendar plan] Get calendar plan'
}

const mutations = {
  [mutationTypes.updateCalendarPlanStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateCalendarPlanSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateCalendarPlanFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getCalendarPlanStart](state) {
    state.isLoading = true
    state.data = null
  },

  [mutationTypes.getCalendarPlanSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getCalendarPlanFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.updateCalendarPlan](context, {id, planInput}) {
    context.commit(mutationTypes.updateCalendarPlanStart)
    return new Promise(resolve => {
      apiCalendarPlan
        .updateCalendarPlan(id, planInput)
        .then(response => {
          context.commit(mutationTypes.updateCalendarPlanSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.updateCalendarPlanFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getCalendarPlan](context, {id}) {
    context.commit(mutationTypes.getCalendarPlanStart)
    return new Promise(resolve => {
      apiCalendarPlan
        .getCalendarPlan(id)
        .then(response => {
          context.commit(mutationTypes.getCalendarPlanSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getCalendarPlanFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
